<template>
<div class="profile-sidebar d-none d-lg-block">
            
    <ProfilePicture 
        :image="picture" 
        @uploaded="profilePictureUpdated" 
    ></ProfilePicture>

    
    <ul>
        <li><router-link tag="a" :to="'/profile'">Mi perfil</router-link></li>
        <li><router-link tag="a" :to="'/bookings'" >Mis reservas</router-link></li>
        <li><router-link tag="a" :to="'/clinic-services'" >Mis exámenes</router-link></li>
        <li><router-link tag="a" :to="'/logout'" >Salir</router-link></li>
    </ul>

</div>
</template>

<script>

import gql from 'graphql-tag'
import { mapGetters } from 'vuex'

import ProfilePicture from '@/components/ProfilePicture';

export default {
    name: 'ProfileSidebar',
    components: {
        ProfilePicture,
    },
    data() {
        return {
            API_URL: process.env.VUE_APP_API_URL,
            loading:true,
            picture: {},
        }
    },
    computed: {
        ...mapGetters(['isAuthenticated','loggedUser'])
    },
	methods:{
        profilePictureUpdated(profilePicture){
            this.picture = profilePicture;
            this.savePicture();
        },
        savePicture(){
            this.loading=true;
            var dataInput = {
				picture: JSON.stringify(this.picture),
			};

			this.$apollo.mutate({
				mutation: gql`mutation ( $data:UserUpdatePictureInput! ){
					userUpdatePicture( data: $data) {
						id
					}
				}`,
				variables: {
					data: dataInput,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados');
                this.loading=false;
            })
            .catch( () => {
                this.$toast.error('Oops!');
                this.loading=false;
            })
        },
    },
    apollo: {
        me: {
            query: gql`query{
                me{
                    id
                    name
                    lastname
                    email
                    picture{
                        id
                        filename
                        urlThumb
                        url
                    }
                }
            }`,
            fetchPolicy: 'no-cache',
            result (data) {
                this.picture = data.data.me.picture;
                this.loading=false;
            },
        }
    },
    
	
}
</script>

<style scoped>
.profile-sidebar{
    width: 100%;
    border: 1px solid #ededed;
    background-color: #fff;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}


ul,
ul li {
    position: relative;
    margin: 0;
    padding: 0;
}
ul li:first-child {
   border-top: 1px solid #ededed;
}
ul li {
   border-bottom: 1px solid #ededed;
}
ul>li>a {
    color: #333;
    padding: 15px !important;
    height: 48px;
    font-size: 14px;
    font-size: 0.875rem;
    font-weight: 500;
    display: flex;
    align-items: center;
}

ul>li:hover>a {
    color: #7ad6cb;
}
</style>
